import React, { ComponentType, ReactNode } from 'react'
import { CardListSection } from 'src/layout/page/section/CardListSection'
import { CardSection } from 'src/layout/page/section/CardSection'
import { Heading } from 'src/ui/text/Heading'
import { css } from 'src/ui/style/css'
import { verticalChildSpacing } from 'src/ui/style/mixins/layout'
import { View } from 'src/ui/basic/View'
import { useTheme } from 'src/ui/style/useTheme'
import { wordWrap } from 'src/ui/style/mixins/other'

export const StaticPage: ComponentType<{
    title: string
    children: ReactNode
}> = ({ title, children }) => {
    const th = useTheme()
    return (
        <CardListSection>
            <CardSection>
                <View css={verticalChildSpacing(th.spacing.md)}>
                    <Heading
                        level={1}
                        css={css`
                            text-align: center;
                            text-transform: uppercase;
                        `}
                    >
                        {title}
                    </Heading>
                    <View
                        css={[
                            verticalChildSpacing(th.spacing.md)(th),
                            wordWrap()
                        ]}
                    >
                        {children}
                    </View>
                </View>
            </CardSection>
        </CardListSection>
    )
}
